export { default } from './memoize-one';
